// Connection path utilities — bezier curves and anchor direction helpers.

function anchorDir(anchor) {
  if (typeof anchor === 'string' && anchor.indexOf('classifier-') === 0) return { x: 1,  y: 0 };
  if (anchor === 'right')  return { x: 1,  y: 0  };
  if (anchor === 'left')   return { x: -1, y: 0  };
  if (anchor === 'bottom') return { x: 0,  y: 1  };
  return                          { x: 0,  y: -1 }; // top
}

function smoothPath(from, to, fromAnchor, toAnchor) {
  var dx = to.x - from.x;
  var dy = to.y - from.y;
  var dist = Math.sqrt(dx * dx + dy * dy);

  if (fromAnchor && toAnchor) {
    var stem = Math.max(60, Math.min(150, dist * 0.45));
    var fd = anchorDir(fromAnchor);
    var td = anchorDir(toAnchor);
    var c1x = from.x + fd.x * stem;
    var c1y = from.y + fd.y * stem;
    var c2x = to.x   + td.x * stem;
    var c2y = to.y   + td.y * stem;
    return 'M ' + from.x + ' ' + from.y + ' C ' + c1x + ' ' + c1y + ' ' + c2x + ' ' + c2y + ' ' + to.x + ' ' + to.y;
  }

  if (fromAnchor) {
    var stem = Math.max(60, Math.min(150, dist * 0.45));
    var fd = anchorDir(fromAnchor);
    var c1x = from.x + fd.x * stem;
    var c1y = from.y + fd.y * stem;
    return 'M ' + from.x + ' ' + from.y + ' C ' + c1x + ' ' + c1y + ' ' + to.x + ' ' + to.y + ' ' + to.x + ' ' + to.y;
  }

  if (Math.abs(dx) > Math.abs(dy)) {
    var curveX = Math.max(40, Math.min(130, Math.abs(dx) * 0.5));
    var c1x = from.x + Math.sign(dx) * curveX;
    var c2x = to.x - Math.sign(dx) * curveX;
    return 'M ' + from.x + ' ' + from.y + ' C ' + c1x + ' ' + from.y + ' ' + c2x + ' ' + to.y + ' ' + to.x + ' ' + to.y;
  }

  var curveY = Math.max(40, Math.min(130, Math.abs(dy) * 0.5));
  var c1y = from.y + Math.sign(dy) * curveY;
  var c2y = to.y - Math.sign(dy) * curveY;
  return 'M ' + from.x + ' ' + from.y + ' C ' + from.x + ' ' + c1y + ' ' + to.x + ' ' + c2y + ' ' + to.x + ' ' + to.y;
}

function smoothPathThroughPoints(points, fromAnchor, toAnchor) {
  if (!Array.isArray(points) || points.length < 2) return '';
  if (points.length === 2) {
    return smoothPath(points[0], points[1], fromAnchor, toAnchor);
  }

  var d = 'M ' + points[0].x + ' ' + points[0].y;
  for (var i = 0; i < points.length - 1; i += 1) {
    var pPrev = i === 0 ? points[0] : points[i - 1];
    var p0 = points[i];
    var p1 = points[i + 1];
    var pNext = i + 2 < points.length ? points[i + 2] : points[points.length - 1];

    var c1x = p0.x + (p1.x - pPrev.x) / 6;
    var c1y = p0.y + (p1.y - pPrev.y) / 6;
    var c2x = p1.x - (pNext.x - p0.x) / 6;
    var c2y = p1.y - (pNext.y - p0.y) / 6;

    if (i === 0 && fromAnchor) {
      var fromDist = Math.sqrt(Math.pow(p1.x - p0.x, 2) + Math.pow(p1.y - p0.y, 2));
      var fromStem = Math.max(40, Math.min(140, fromDist * 0.45));
      var fd = anchorDir(fromAnchor);
      c1x = p0.x + fd.x * fromStem;
      c1y = p0.y + fd.y * fromStem;
    }

    if (i === points.length - 2 && toAnchor) {
      var toDist = Math.sqrt(Math.pow(p1.x - p0.x, 2) + Math.pow(p1.y - p0.y, 2));
      var toStem = Math.max(40, Math.min(140, toDist * 0.45));
      var td = anchorDir(toAnchor);
      c2x = p1.x + td.x * toStem;
      c2y = p1.y + td.y * toStem;
    }

    d += ' C ' + c1x + ' ' + c1y + ' ' + c2x + ' ' + c2y + ' ' + p1.x + ' ' + p1.y;
  }

  return d;
}

// Point on the same cubic bezier smoothPath() draws, at parameter t (0..1).
// t=0.5 is the visual midpoint; other values let callers place UI (e.g. the
// insert button) along the connector without stacking on the midpoint label.
function bezierPointAt(from, to, fromAnchor, toAnchor, t) {
  var dx = to.x - from.x;
  var dy = to.y - from.y;
  var dist = Math.sqrt(dx * dx + dy * dy);
  var stem = Math.max(60, Math.min(150, dist * 0.45));
  var fd = anchorDir(fromAnchor || 'right');
  var td = anchorDir(toAnchor || 'left');
  var c1x = from.x + fd.x * stem;
  var c1y = from.y + fd.y * stem;
  var c2x = to.x + td.x * stem;
  var c2y = to.y + td.y * stem;
  var mt = 1 - t;
  var a = mt * mt * mt;
  var b = 3 * mt * mt * t;
  var c = 3 * mt * t * t;
  var d = t * t * t;
  var x = a * from.x + b * c1x + c * c2x + d * to.x;
  var y = a * from.y + b * c1y + c * c2y + d * to.y;
  return { x: Math.round(x), y: Math.round(y) };
}

function bezierMidpoint(from, to, fromAnchor, toAnchor) {
  return bezierPointAt(from, to, fromAnchor, toAnchor, 0.5);
}

module.exports = {
  anchorDir: anchorDir,
  smoothPath: smoothPath,
  smoothPathThroughPoints: smoothPathThroughPoints,
  bezierMidpoint: bezierMidpoint,
  bezierPointAt: bezierPointAt
};
